import axios from 'axios';
import { adalGetToken } from 'react-adal';
import { authContext, adalConfig } from './configAdal';

const instance = axios.create({
    timeout: 100000,
    headers: {'Content-Type': 'application/json'},
    withCredentials: true,
  });

  const authorizedRequest = options => {
    const { clientId } = adalConfig;
  
    return adalGetToken(authContext, clientId).then(token => {
      if (token) {
        const o = options || {};
        if (!o.headers) o.headers = {};
        o.headers.Authorization = 'Bearer ' + token;
        return instance.request(o);
      } else {
        console.log('Unable to get token');
        throw new Error('Unable to get token');
      }
    });
  };

  const asyncRequest = {
    get: url => authorizedRequest({url}),
    post: (url, data) => authorizedRequest({method: 'POST', url, data}),
  }

  export default asyncRequest;

